/**
 * Flight alert texts: the customer's switch (server/flight-status-sms.js,
 * /api/text-alerts). Both calls carry the signed-in session and answer
 * { available, enabled, phone, phone_display }. `available` is false until
 * texts are switched on, and nothing about texts shows then.
 */
import { supabase } from '@/lib/supabase';
import { getApiUrl } from '@/lib/apiUrls';

async function call(method, body) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Not signed in');
  const res = await fetch(getApiUrl('text-alerts'), {
    method,
    headers: { Authorization: `Bearer ${session.access_token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json?.error || `Text alerts unavailable (HTTP ${res.status})`);
  return json;
}

export const textAlertsApi = {
  get: () => call('GET'),
  /** source: 'checkout' | 'trip_page' | 'account' */
  turnOn: ({ phone, source }) => call('PUT', { enabled: true, phone, source }),
  turnOff: () => call('PUT', { enabled: false }),
};
